export default __webpack_public_path__ + "static/media/about1.469d350e.png";